import React from 'react';
import {SectionTitle} from 'components/items';
import {BtnText} from 'components/btns';
import makeTitle from 'function/makeTitle.js';
import download from 'download/donggubat_portfolio.pdf'

const sectionTitle = [
  {
    text: "OUR",
    color: "defualt",
    break: false
  },{
    text: "VALUE",
    color: "main",
    break: true
  }
]

const values = [
  {
    id: "value-01",
    value: "Remarkable",
    text: "팩토리의 독자적인 기술력과 레시피를 기반으로 뛰어난 기능의 제품을 선보이는 브랜드를 추구합니다."
  },{
    id: "value-02",
    value: "Sustainable",
    text: "발달장애인 자립과 환경, 고객의 지속가능함을 생각하는 브랜드를 추구합니다."
  },{
    id: "value-03",
    value: "Diversity",
    text: "동구밭 구성원들의 다양성과 다양한 고객을 포용하는 차별적인 아이덴티티를 가진 브랜드를 추구합니다."
  },{
    id: "value-04",
    value: "Reliable",
    text: "발달장애인 자립과 환경, 고객의 지속가능함을 생각하는 브랜드를 추구합니다."
  },
]

const OurValue = () => {

  const drawValues = () => {
    return values.map(el=> {
      return  <li className = "list-value" key = {el.id}>
                <div className="value-border">
                  <p className="value-title">{el.value}</p>
                </div>
                <p className="value-text">{el.text}</p>
              </li>
    })
  }

  return (
    <section className="OurValue bgColor-lightGrey">
      <div className="section-header">
        <div className="con">
          <SectionTitle  text = {makeTitle(sectionTitle)}  type = "center"/>
        </div>
      </div>

      <div className="section-contents">
        <div className="con">
          <ul className="wrap-values">
            {drawValues()}
          </ul>

          <BtnText text = "회사소개서 다운로드" className = "bgColor-main" to = {download} download = {'20200121_회사소개서.pdf'}/>
        </div>
      </div>
    </section>
  );
}

export default OurValue;